import { GeometryChange } from "../../util/geometry/types";
import { Action } from "redux";
import { Feature } from "../../../core/geo/types";

export const GEOMETRY_CHANGED = "GEOMETRY_CHANGED";

export interface GeometryChangedAction extends Action {
    change: GeometryChange[];
    changedFeature: Feature;
    shouldWaitForPortal: boolean;
}

export const geometryChangedAction = (
    change: GeometryChange[],
    changedFeature: Feature,
    shouldWaitForPortal: boolean
): GeometryChangedAction => {
    return {
        type: GEOMETRY_CHANGED,
        change: change,
        changedFeature: changedFeature,
        shouldWaitForPortal: shouldWaitForPortal,
    };
};
